/* eslint-disable */
export default {
  _burp: 'burp',
  _cartoon_scramble: 'cartoon_scramble',
  _cartoon_win: 'cartoon_win',
  _cartoon_pop: 'cartoon-pop',
  _chocolates_fell_out: 'chocolates-fell-out',
  _chocolatey: 'chocolatey',
  _chomp_05: 'chomp-05',
  _click: 'click',
  _gooey: 'gooey',
  _mmmm: 'mmmm',
  _sweetness: 'sweetness',
  _swish: 'swish',
  _tap_to_eat: 'tap-to-eat',
  _title: 'title',
  _you_ate_all: 'you-ate-all',
}